<template>
  <modal :title="modalTitle" ref="splaModal" :size="'modal-md'" @save="saveSpla(splaLicence)">
    <div class="row row-spacing justify-content-center">
      <div class="col-md-12 justify-content-center">
          <div class="col-md-12">
            <h4>Service Provider Licence Agreement</h4>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>SPLA Package</label>
                  <v-select
                  :options="splaPackages"
                  valueProp="hostAfricaSplaPackageNumber"
                  label="description"
                  v-model="
                    splaLicence.hostAfricaSplaPackageNumber
                  "
                ></v-select>
              </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Quantity</label>
                  <input type="text" class="form-control" v-model="splaLicence.quantity" />
              </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/GeneralComponents/Modal";

export default {
  components: {
    Modal,
  },
  props: {
    modalTitle: {
      type: String,
      required: true,
    },
    splaLicence: {
      type: Object,
      required: true,
    },
    splaPackages: {
      type: Array,
      required: true,
    },
    saveText: {
      type: String,
      default: "Save",
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
  },
  methods: {
    open: function () {
      this.$refs.splaModal.open();
    },
    saveSpla: function (spla) {
      this.$emit("saveSplaLicence", spla);
      this.$refs.splaModal.close();
    },
  },
};
</script>